import { render, staticRenderFns } from "./QuestionCollectionAddToSurveyDialog.vue?vue&type=template&id=b0d441ba&"
import script from "./QuestionCollectionAddToSurveyDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionCollectionAddToSurveyDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VForm,VList,VListItem,VListItemContent,VSkeletonLoader})
